module.exports = __webpack_public_path__ + "img/2300f.dace7ee8.png";